import { render, staticRenderFns } from "./SurveyLimit.vue?vue&type=template&id=0b19211c&scoped=true&"
import script from "./SurveyLimit.vue?vue&type=script&lang=ts&"
export * from "./SurveyLimit.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyLimit.vue?vue&type=style&index=0&id=0b19211c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19211c",
  null
  
)

export default component.exports